import { initializeApp } from 'firebase/app';
import { ReCaptchaV3Provider, initializeAppCheck } from 'firebase/app-check';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

// Set debug token for local development
const debugToken = import.meta.env.VITE_RECAPTCHA_DEBUG_TOKEN;
const siteKey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

if (!siteKey) {
  console.warn(
    '⚠️ VITE_RECAPTCHA_SITE_KEY is not set. App Check may not work correctly.'
  );
}

if (debugToken) {
  // @ts-expect-error: FIREBASE_APPCHECK_DEBUG_TOKEN is allowed for debugging AppCheck
  self.FIREBASE_APPCHECK_DEBUG_TOKEN = debugToken;
  console.log('🔧 App Check: Using debug token');
}

// Initialize App Check - tokens are fetched automatically when needed
initializeAppCheck(app, {
  provider: new ReCaptchaV3Provider(siteKey),
  isTokenAutoRefreshEnabled: true,
});

export const db = getFirestore(app);
export const functions = getFunctions(app);
export const auth = getAuth(app);

export default app;
